import { BrowserRouter, Switch, Route } from "react-router-dom";
// Components
import VerifyEmail from "../views/Verify-Email";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path={`/home/:token`} component={VerifyEmail} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
